import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

/**
 * Estilos integrados del componente
 */
const LoginStyles = () => {
  const css = `
    @import url('https://fonts.googleapis.com/css?family=Montserrat:400,800');

    html, body {
        margin: 0;
        padding: 0;
    }

    * {
        box-sizing: border-box;
    }

    .login-app-wrapper {
        background: #f6f6f6;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-family: 'Montserrat', sans-serif;
        min-height: 100vh; 
        margin: 0;
        padding: 30px 0;
        width: 100%;
    }

    .container h1 {
        font-weight: bold;
        margin: 0 0 10px;
    }

    .gradient-text {
        font-size: 48px;
        font-weight: 800;
        margin-bottom: 20px;
        background: linear-gradient(to right, #0057B7, #00BFA5); /* Colores ajustados al tema premium */
        -webkit-background-clip: text; 
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: transparent; 
    }
    
    p {
        font-size: 14px;
        font-weight: 100;
        line-height: 20px;
        letter-spacing: 0.5px;
        margin: 20px 0 30px;
    }

    a {
        color: #333;
        font-size: 14px;
        text-decoration: none;
        margin: 15px 0;
    }

    button {
        border-radius: 20px;
        border: 1px solid #0057B7;
        background: linear-gradient(to right, #0057B7, #00BFA5);
        color: #FFFFFF;
        font-size: 12px;
        font-weight: bold;
        padding: 12px 45px;
        letter-spacing: 1px;
        text-transform: uppercase;
        transition: transform 80ms ease-in;
        cursor: pointer;
    }

    button:active {
        transform: scale(0.95);
    }

    button.ghost {
        background-color: transparent;
        border-color: #FFFFFF;
    }

    form {
        background-color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 0 50px;
        height: 100%;
        text-align: center;
    }

    .input-group {
        position: relative;
        width: 100%;
        margin: 8px 0; 
    }

    .input-group input {
        width: 100%;
        padding: 12px 15px; 
        border-radius: 4px; 
        border: 1px solid #ccc;
        background-color: #eee;
        transition: border-color 0.3s ease;
    }

    .input-group input:focus {
        outline: none;
        border-color: #0057B7;
    }
    
    .input-group label {
        position: absolute;
        top: 50%; 
        left: 15px;
        transform: translateY(-50%);
        color: #999;
        pointer-events: none; 
        transition: 0.3s ease all;
        padding: 0 5px;
    }

    .input-group input:focus + label,
    .input-group input:valid + label {
        top: -12px; 
        left: 10px; 
        transform: translateY(0) scale(0.85); 
        font-weight: bold;
        color: #0057B7;
        background-color: #f6f6f6;
        border: 1px solid #0057B7;
    }
    
    .container {
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
        position: relative;
        overflow: hidden; 
        width: 768px;
        max-width: 100%;
        min-height: 480px;
    }

    .form-container {
        position: absolute;
        top: 0;
        height: 100%;
        transition: all 0.6s ease-in-out;
    }

    .sign-in-container {
        left: 0;
        width: 50%;
        z-index: 2; 
    }

    .sign-up-container {
        left: 0;
        width: 50%;
        opacity: 0;
        z-index: 1; 
    }

    .overlay-container {
        position: absolute;
        top: 0;
        left: 50%;
        width: 50%;
        height: 100%;
        overflow: hidden;
        transition: transform 0.6s ease-in-out;
        z-index: 100;
    }

    .overlay {
        background: linear-gradient(to right, #0057B7, #00BFA5);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 0 0;
        color: #fff;
        position: relative;
        left: -100%;
        height: 100%;
        width: 200%;
        transform: translateX(0);
        transition: transform 0.6s ease-in-out;
    }

    .overlay-panel {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 0 40px;
        text-align: center;
        top: 0;
        height: 100%;
        width: 50%;
        transform: translateX(0);
        transition: transform 0.6s ease-in-out;
    }

    .overlay-right { right: 0; transform: translateX(0); }
    .overlay-left { transform: translateX(-20%); }

    .container.right-panel-active .sign-in-container { transform: translateX(100%); }
    .container.right-panel-active .overlay-container{ transform: translateX(-100%); }
    .container.right-panel-active .sign-up-container { transform: translateX(100%); opacity: 1; z-index: 5; }
    .container.right-panel-active .overlay { transform: translateX(50%); }
    .container.right-panel-active .overlay-left { transform: translateX(0); }
    .container.right-panel-active .overlay-right { transform: translateX(20%); }

    .status-message {
        padding: 10px;
        border-radius: 5px;
        margin-bottom: 15px;
        font-size: 0.9rem;
        width: 100%;
        max-width: 768px;
        text-align: center;
        border: 1px solid;
    }
    .error { color: #e74c3c; background: #fdeaea; border-color: #e74c3c; }
    .success { color: #27ae60; background: #eafaf1; border-color: #2ecc71; }
  `;
  return <style>{css}</style>;
};

export default function LoginPage() {
  const [isPanelActive, setIsPanelActive] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [nombre, setNombre] = useState('');
  const [message, setMessage] = useState({ text: '', type: '' });

  const { login, loginWithGoogle, signup, logout } = useAuth();
  const navigate = useNavigate();

  const handleSignUpClick = () => {
    setMessage({ text: '', type: '' });
    setIsPanelActive(true);
  };

  const handleSignInClick = () => {
    setMessage({ text: '', type: '' });
    setIsPanelActive(false);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setMessage({ text: '', type: '' });
      const userCredential = await login(email, password);
      const user = userCredential.user;

      const userDoc = await getDoc(doc(db, "users", user.uid));

      if (userDoc.exists() && userDoc.data().approved === true) {
        navigate('/');
      } else {
        await logout();
        setMessage({
          text: 'Tu cuenta aún no ha sido aprobada por un administrador.',
          type: 'error'
        });
      }
    } catch (err) {
      if (err.code === 'auth/invalid-login-credentials' || err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
        setMessage({ text: 'Credenciales incorrectas.', type: 'error' });
      } else {
        setMessage({ text: 'Credenciales incorrectas o error de servidor.', type: 'error' });
      }
    }
  };

  const handleGoogleLogin = async () => {
    try {
      setMessage({ text: '', type: '' });
      const result = await loginWithGoogle();
      const userDoc = await getDoc(doc(db, "users", result.user.uid));
      
      if (userDoc.exists() && userDoc.data().approved === true) {
        navigate('/');
      } else {
        await logout();
        setMessage({
          text: 'Tu cuenta aún no ha sido aprobada por un administrador.',
          type: 'error'
        });
      }
    } catch (err) {
      if (err.code !== 'auth/popup-closed-by-user') {
         setMessage({ text: 'Error al iniciar sesión con Google.', type: 'error' });
      }
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      setMessage({ text: '', type: '' });
      await signup(email, password, nombre);
      setMessage({
        text: 'Registro completado. Espera a que un administrador apruebe tu acceso.',
        type: 'success'
      });
      setIsPanelActive(false);
    } catch (err) {
      setMessage({ text: 'Error al crear la cuenta. Intenta con otro correo.', type: 'error' });
    }
  };

  return (
    <>
      <LoginStyles />
      <div className="login-app-wrapper">
        <h1 className="gradient-text">Sistema de Gestión de Vallas</h1>

        {message.text && (
          <div className={`status-message ${message.type}`}>
            {message.text}
          </div>
        )}

        <div className={`container ${isPanelActive ? "right-panel-active" : ""}`} id="container">

          <div className="form-container sign-up-container">
            <form onSubmit={handleRegister}>
              <h1>Crear Cuenta</h1>
              <div className="input-group">
                <input type="text" required value={nombre} onChange={(e) => setNombre(e.target.value)} />
                <label>Nombre</label>
              </div>
              <div className="input-group">
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
                <label>Email</label>
              </div>
              <div className="input-group">
                <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
                <label>Contraseña</label>
              </div>
              <button type="submit">Registrarse</button>
            </form>
          </div>

          <div className="form-container sign-in-container">
            <form onSubmit={handleLogin}>
              <h1>Iniciar Sesión</h1>
              <div className="input-group">
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
                <label>Email</label>
              </div>
              <div className="input-group">
                <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
                <label>Contraseña</label>
              </div>
              <a href="#">¿Olvidaste tu contraseña?</a>
              <button type="submit">Login</button>
              <div style={{ marginTop: '15px' }}>
                <button type="button" className="ghost" style={{ backgroundColor: '#fff', color: '#0057B7', border: '1px solid #0057B7', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '10px 25px' }} onClick={handleGoogleLogin}>
                  <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" width="16" alt="Google" />
                  Ingresar con Google
                </button>
              </div>
            </form>
          </div>

          <div className="overlay-container">
            <div className="overlay">
              <div className="overlay-panel overlay-left">
                <h1>¡Bienvenido de Nuevo!</h1>
                <p>Inicia sesión en Sistema de Gestión de Vallas para acceder a tu cuenta.</p>
                <button className="ghost" id="signIn" onClick={handleSignInClick}>Login</button>
              </div>
              <div className="overlay-panel overlay-right">
                <h1>¡Hola, Amigo!</h1>
                <p>Regístrate en Sistema de Gestión de Vallas para enviar tu solicitud de acceso.</p>
                <button className="ghost" id="signUp" onClick={handleSignUpClick}>Registrarse</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
